export default "__VITE_PUBLIC_ASSET__1daf6dc4__"